import { RGB } from "."

const GREY: RGB = [192, 192, 192]

const {floor} = Math
const toScalar = ([r, g, b]: RGB) => 256*256*r + 256*g + b
const toHex = (rgb: RGB) => `#${toScalar(rgb).toString(16).padStart(6, '0')}`

export class Material {
  transparentColour: RGB
  offColour: RGB

  constructor(
    public readonly colour: RGB,
    public readonly shininess: number,
    public readonly opacity: number,
    transparentColour?: RGB,
    offColour?: RGB,
  ) {
    this.transparentColour = transparentColour || colour
    this.offColour = offColour || GREY
  }

  darker() {
    const [r, g, b] = this.colour.map(c => floor(c*0.7))
    return `rgb(${r},${g},${b})`
  }

  hex() {
    return toHex(this.colour)
  }

  isPale() { return this.colour.every(c => c > 170) }

  offHex() {
    return toHex(this.offColour)
  }

  rgba(a=1) {
    const [r, g, b] = this.colour
    return `rgba(${r},${g},${b},${a})`
  }

  scalar() {
    return toScalar(this.colour)
  }

  transparentHex() {
    return toHex(this.transparentColour)
  }

  // helper method for UI to provide contrast
  // when rendering pale colours
  backgroundHex() {
    return this.isPale() ? this.darker() : this.rgba(0.2)
  }
}
